import { Box, Divider, Stack, Typography } from "@mui/material";

export default function CardHeader({ title, icon, hasDivider = false }) {

  return (
    <Box sx={{ width: "100%" }}>
      <Stack
        direction="row"
        spacing={3}
        alignItems="center"
        sx={{ px: 2.25, pt: 2, pb: 1.5, alignSelf: "flex-start" }}
      >
        {icon}

        <Typography variant="h6" fontWeight="bold">
          {title}
        </Typography>
      </Stack>

      {hasDivider && <Divider sx={{ ml: "1rem", mr: "1rem" }} />}
    </Box>
  )
}